/**
 * HTML → Klartext, bewusst OHNE DOM.
 *
 * Gebraucht von zwei reinen Ableitungen, die im node-Runner laufen: dem
 * Archiv (`archivZeilen.ts`, Suchtext und Zeilentitel einer HTML-Notiz) und
 * den Ereignisblöcken (`ereignisBloecke.ts`, der Textauszug einer
 * Termin-Notiz auf der Karte). `blockHtml.ts` brächte DOMPurify und damit ein
 * Fenster mit; hier reicht ein Tag-Strip, weil das Ergebnis als TEXT gerendert
 * wird — nie als Markup. Dasselbe Vorgehen wie `istLeererBlocktext`.
 *
 * Bilder werden als `[Bild]` benannt, damit reine Bildnotizen im Archiv nicht
 * verschwinden. Zeilentrenner (`<br>`, Absatz- und Listenenden) werden zu
 * Leerzeichen, alle übrigen Tags fallen weg, die fünf Entitäten eines
 * `contentEditable` kommen zurück, Weißraum wird auf ein Leerzeichen gezogen.
 */
export function htmlZuKlartext(html: string): string {
    return (html ?? "")
        .replace(/<img\b[^>]*>/gi, " [Bild] ")
        .replace(/<\s*(br|\/p|\/div|\/li|\/h[1-6]|\/tr)\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, " ")
        .trim();
}
